import React from 'react'
import { set } from 'lodash'
import {
  Create,
  SimpleForm,
  ReferenceInput,
  TextInput,
  SelectInput,
  DateInput,
  FileField,
  required,
  BooleanInput,
} from 'react-admin'
import FileInput from '../../components/FileInput'
import { parse } from 'query-string'
import ClearFix from '../../components/ClearFix'

export default props => {
  const { contract_id } = parse(props.location.search)
  const redirect = contract_id
    ? `/node/contract/${contract_id}/show/agreement`
    : false

  return (
    <Create {...props}>
      <SimpleForm
        defaultValue={set(
          {},
          'relationships.field_contract.data.id',
          contract_id
        )}
        redirect={redirect}
      >
        <ReferenceInput
          style={{ display: 'none' }}
          source='relationships.field_contract.data.id'
          reference='node/contract'
          validate={required()}
        >
          <SelectInput optionText='attributes.title' />
        </ReferenceInput>

        <TextInput
          formClassName='col-xs-12 col-sm-6 col-md-5 col-lg-4'
          fullWidth={true}
          source='attributes.field_id'
          validate={required()}
        />
        <TextInput
          formClassName='col-xs-12 col-sm-6 col-md-5 col-lg-4'
          fullWidth={true}
          source='attributes.title'
          validate={required()}
        />
        <ClearFix formClassName='clearfix' />

        <DateInput
          formClassName='col-xs-12 col-sm-6 col-md-5 col-lg-4'
          fullWidth={true}
          source='attributes.field_date_start'
        />
        <DateInput
          formClassName='col-xs-12 col-sm-6 col-md-5 col-lg-4'
          fullWidth={true}
          source='attributes.field_date_end'
        />
        <ClearFix formClassName='clearfix' />

        <BooleanInput
          formClassName='col-xs-12 col-sm-6 col-md-5 col-lg-4'
          fullWidth={true}
          source='attributes.field_prolongation'
        />
        <FileInput
          formClassName='col-xs-12'
          fullWidth={true}
          source='included.field_files'
          accept='application/pdf'
        >
          <FileField
            source='attributes.uri.url'
            title='attributes.filename'
            target='_blank'
          />
        </FileInput>
        <TextInput
          multiline
          formClassName='col-xs-12'
          fullWidth={true}
          source='attributes.body.value'
        />
      </SimpleForm>
    </Create>
  )
}
